import { Controller } from "stimulus";
import StimulusReflex from "stimulus_reflex";
import $ from "jquery";
import debounced from "debounced";
import throttle from "lodash/throttle";
import debounce from "lodash/debounce";
import intlTelInput from 'intl-tel-input';
import  { Fancybox }  from "@fancyapps/ui/src/Fancybox";
import Inputmask from "inputmask";

// Import TinyMCE
import tinymce from 'tinymce/tinymce'

/* import tinymce langs */
import "../src/vendor/tinymce/langs/fr_FR"
import "../src/vendor/tinymce/langs/es_419"

// Import icons
import 'tinymce/icons/default/icons'

// Import theme
import 'tinymce/themes/silver/theme';

// Import skin
import 'tinymce/skins/ui/oxide/skin.min.css';

/* Import content css */
//import contentUiCss from 'tinymce/skins/ui/oxide/content.min.css';
//import contentCss from 'tinymce/skins/content/default/content.css';

/* tinymce plugins */
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/autosave';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/code';
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/emoticons/js/emojis.min'
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/help';
import 'tinymce/plugins/image';
import 'tinymce/plugins/importcss';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/media';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/print';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/table';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/visualchars';
import 'tinymce/plugins/wordcount';

//require ('tui-time-picker/dist/tui-time-picker.css');
//require ("tui-calendar/dist/tui-calendar.css");

//import Calendar from "tui-calendar";

//select2 plugin
require("select2/dist/css/select2");
require("select2-bootstrap-theme/dist/select2-bootstrap");
import Select2 from "select2";

/* This is your ApplicationController.
 * All StimulusReflex controllers should inherit from this class.
 *
 * Example:
 *
 *   import ApplicationController from './application_controller'
 *
 *   export default class extends ApplicationController { ... }
 *
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends Controller {
  constructor(...args) {
    super(...args);

    this.previouslyFocusedElement = null;
  }
  connect() {
    MicroModal.init();
    debounced.initialize({ input: { wait: 300 } });
    debounced.initialize({ keyup: { wait: 500 } });
    console.log("Application JS en cours ...");

    StimulusReflex.register(this);
    window.Fancybox = Fancybox;
    let langs = {
      "fr": "fr_FR",
      "en": "en_US"
    }
    let currentLanguageElem = document.getElementById('user-current-language')
    let tinyLang = "fr_FR"
    if (currentLanguageElem !== null && currentLanguageElem.value.length > 0 ) {
      tinyLang = langs.hasOwnProperty(currentLanguageElem.value) ? langs[currentLanguageElem] : "fr_FR"
    }
    tinymce.init({
      selector: '.tinymce',
      height: 300,
      menubar: true,
      skin: false,
      content_css: false,
      language: tinyLang,
      //language_url: '/packs/js/application.js',
      //content_style: contentUiCss.toString()+ "\n"+contentCss.toString(),
      plugins: [
        'advlist autolink emoticons lists link image charmap print preview anchor',
        'searchreplace visualblocks code codesample fullscreen',
        'insertdatetime media table paste code help wordcount'
      ],
      // tinymce5 toolbar items
      toolbar: 'language|'+
          'undo redo | fontselect fontsizeselect |' +
          ' bold italic underline forecolor backcolor | alignleft aligncenter ' +
          ' alignright alignjustify | bullist numlist outdent indent | ' +
          ' removeformat | help',
      // content_langs: [
      //   { title: 'English', code: 'en_US' },
      //   { title: 'French', code: 'fr_FR' },
      //   { title: 'Spanish', code: 'es_419'}
      // ],
      insertdatetime_formats: [
        '%H:%M:%S',
        '%I:%M:%S %p',
        '%d-%m-%Y',
        '%d/%m/%Y',
        '%d %B %Y',
        '%d %b %Y',
        '%Y/%m/%d',
        '%Y-%m-%d',
        '%D'
      ]
    });

    function templateResult(item, container) {
      // replace the placeholder with the break-tag and put it into an jquery object
      return $('<span>' + item.text.replace('[br]', '<br/>') + '</span>');
    }

    function templateSelection(item, container) {
      // replace your placeholder with nothing, so your select shows the whole option text
      return item.text.replace('[br]', '');
    }
    if ($(".content-search") && !$(".content-search").hasClass("select2-hidden-accessible") ) {
      if ($(".content-search").hasClass("no-close-select")) {
          $(".content-search").select2({
            
            width: "resolve",
            placeholder: "",
            allowClear: true,
            templateResult: templateResult,
            templateSelection: templateSelection,
            closeOnSelect: false
          });

        } else {
          $(".content-search").select2({
            
            width: "resolve",
            placeholder: "",
            allowClear: true,
            templateResult: templateResult,
            templateSelection: templateSelection
          });

        }
    }
    $(".content-search").on('select2:select', function () {
      let event = new Event('change', { bubbles: true }) // fire a native event
      this.dispatchEvent(event);
    });
    $(".content-search").on("select2:unselect", function () {
      let event = new Event("change", { bubbles: true }); // fire a native event
      this.dispatchEvent(event);
    });
    this.load_show_edit_destroy();
    var self = this;
    this.initIntTel();

    function getParentsClassNames(elem, className) {
      var parents = [];
      while (
          elem.parentNode &&
          elem.parentNode.nodeName.toLowerCase() != "body"
          ) {
        elem = elem.parentNode;
        if (elem.className && elem.className.includes(className)) {
          parents.push(elem.className);
        }
      }
      return parents;
    }
    document.addEventListener("click", function (evt) {
      let sidebar = document.getElementById("fx-sidebar-menu");
      if (!hasClass(sidebar, "fx-close")) {
        if (sidebar && (evt.target.style.zIndex < sidebar.style.zIndex)) {
          sidebar.classList.toggle("fx-close");
        }
      }
      if (self.isopened == 1 && evt.target.id != "main") {
        let condition_select2 =
            getParentsClassNames(evt.target, "select2").length == 0;
        let condition_flatpickr =
            getParentsClassNames(evt.target, "flatpickr").length == 0;

        if (
            document.getElementById("mySidebar") &&
            evt.target.style.zIndex <
            document.getElementById("mySidebar").style.zIndex &&
            condition_flatpickr &&
            condition_select2
        ) {
          self.toggle();
        }
      } else {
      }
    });

    document.addEventListener("keydown", function (evt) {
      if (self.isopened == 1) {
        let code = evt.keyCode;
        if (code == 27) {
          self.toggle();
        }
      }
    });
    function getCurrentHeight(ids) {
      let height = 0;
      for (var i = 0; i < ids.length; i++) {
        if (document.getElementById(ids[i])) {
          height = height + document.getElementById(ids[i]).offsetHeight;
        }
      }
      return height;
    }
    function hasClass(element, className) {
      return (
          (" " + element.className + " ").indexOf(" " + className + " ") > -1
      );
    }

    // Récupération des éléments html qu'on aimerait manipuler dans la fontion documentIsCrolled par le biais de leur ID
    let navbar = document.getElementById("navbar");
    let cadre = document.getElementById("onglet-cadre");
    let btl = document.getElementById("barre-titre-liste");
    let sticky = btl?.offsetTop;

    // console.log(`fx logger : ${btl}`);
    // console.log(`fx logger : ${btl}`);
    // console.log(`fx logger : ${btl}`);
    // console.log(`fx logger : ${btl}`);

    var quick_sort = document.getElementById("quick_sort");
    var search = document.getElementById("search");
    let main = document.getElementById("main");
    // let nav_bar_right_dd = document.getElementById("nav_bar_right_dd");
    let footerSection = $(".footer-section");
    if (main) {
      main.classList.add("openbtn_right");
    }
    //la ligne suivante  permet de savoir si l'utilisateur est en train de scroller la page
    window.onscroll = function () {
      if (is.not.safari() && quick_sort) {
        documentIsCrolled();
      }
    };
    /*Le but de cette fonction est de fixer le menu et certains éléments de la page
     *en haut du document quand l'utilisateur scroll vers le bas */


    function documentIsCrolled() {

      //Récupération des éléments html qu'on aimerait manipuler par le biais de leur ID
      let table1 = document.getElementById("table1");
      let cHeader = document.getElementById("c-header");
      let topSeparator = document.getElementById("top-separator-td");
      var quick_sort = document.getElementById("quick_sort");
      var search = document.getElementById("search");

      if (window.pageYOffset >= sticky - 59) {

        // if (navbar) {
        //   footerSection.css("paddingTop", "18%"
        //   );
        //   // navbar.style.paddingTop = ".20cm";
        //   navbar.classList.add("sticky");
        //   // nav_bar_right_dd.style.position = "fixed";
        // }
        if (btl) {
          btl.classList.add("sticky_header_a");
          btl.style.top = getCurrentHeight(["navbar"]) + "px";
          btl.style.zIndex = "3";
          btl.style.width = "calc(100% - 95px)";
        }
        if (cadre) {
          cadre.style.top = getCurrentHeight(["navbar"]) + "px";
          cadre.classList.add("sticky");
          cadre.style.backgroundColor = hasClass(cadre, "c_vert")
              ? "white"
              : "#9dbacc";
          cadre.style.zIndex = "3";
        }
        if (cHeader) {
          cHeader.style.top =
              getCurrentHeight(["navbar", "onglet-cadre", "top-separator-td"]) - "px";
          cHeader.classList.add("sticky_header");
        }
        if (topSeparator) {
          topSeparator.style.top =
              getCurrentHeight(["navbar", "onglet-cadre"])  + "px";
          topSeparator.style.position = "sticky";
        }
        if (table1) {
          table1.style.borderCollapse = "separate";
        }
        if (quick_sort) {
          quick_sort.style.top =
              getCurrentHeight(["navbar", "barre-titre-liste"])  + "px";
          quick_sort.classList.add("sticky_header");
          quick_sort.style.zIndex = "6";
        }
        if (search) {
          search.style.top =
              getCurrentHeight(["navbar", "barre-titre-liste", "quick_sort"]) + "px";
          search.style.zIndex = "6";
          search.style.position = "sticky";
        }

        if (main) {
          main.style.zIndex = "6";
        }
    // sticky = 59;

        // console.log(`sticky dans le if ${sticky}  et  ${window.pageYOffset}`);
      } else {

        // console.log(`sticky dans le if ${sticky}  et  ${window.pageYOffset}`);
        // if (navbar) {
        //   navbar.classList.remove("sticky");
        //   navbar.style.paddingTop = "unset";
        //   footerSection.css("paddingBottom", "unset");
        //   // nav_bar_right_dd.style.position = "";
        // }
        if (cadre) {
          cadre.classList.remove("sticky");
          cadre.style.paddingTop = "0";
          cadre.style.zIndex = "0";
        }
        if (cHeader) {
          cHeader.classList.remove("sticky_header");
          cHeader.style.top = "unset";
          cadre.style.backgroundColor = "unset";
        }
        if (topSeparator) {
          // topSeparator.classList.remove("sticky_separator");
          topSeparator.style.top = "unset";
          topSeparator.style.position = "unset";
        }
        if (btl) {
          btl.classList.remove("sticky_header_a");
          btl.style.top = "unset";
          btl.style.width = "100%";
        }
        if (table1) {
          table1.style.borderCollapse = "collapse";
        }
        if (quick_sort) {
          quick_sort.classList.remove("sticky_header");
          quick_sort.style.top = "unset";
        }

        if (search) {
          search.classList.remove("sticky");
          search.style.top = "unset";
          //search.style.zIndex = "unset";
        }
      }
    }

    ////
    $('#mySidebar #table_custom_ .switch input').each(function(){
      let me = $(this)
      if ( me && (me.attr('type') === 'checkbox') && ( me.attr('class').includes('preference_columns') )) {
        me[0].addEventListener("change", (e) => {
          let hiddenHtmlClass = e.target.id.replace('filterrific_','')
          // console.log(hiddenHtmlClass)
          if (e.target.checked) {
            // console.log("show ",e.target)
            $('.' + hiddenHtmlClass).show()
            $("#colspan_datas").attr("colspan", parseInt($("#colspan_datas").attr("colspan")) + 1 );
            $("#colspan_footer").attr("colspan", parseInt($("#colspan_footer").attr("colspan")) + 1);
          } else {
            // console.log("hide ",e.target)
            $('.' + hiddenHtmlClass).hide();
            $("#colspan_datas").attr("colspan", parseInt($("#colspan_datas").attr("colspan")) - 1);
            $("#colspan_footer").attr("colspan", parseInt($("#colspan_footer").attr("colspan")) - 1);
          }
        })
      }
    })
    /////
    ///// Changement de couleur design
    function hexToRgb(hex) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? "rgb(" + parseInt(result[1], 16) + "," + parseInt(result[2], 16) + "," + parseInt(result[3], 16) + ")" : null;
    }
    if ($("#condition_change_color").val() == "true" ){
      var newColor = $("#new_color_1").val();
      var oldColor = "#3fb0ac";
      var oldColor_bis = "#3eb0ac"
      var newColor2 = $("#new_color_1").val();
      var oldColor2 = "#1d5050";
      $("*").css("color", function (i, val) {
        val = val.replace(/\s/g, "");
        if (val == oldColor || val == hexToRgb(oldColor) || val.includes(oldColor) || val.includes(hexToRgb(oldColor)) || val == oldColor_bis || val == hexToRgb(oldColor_bis) || val.includes(oldColor_bis) || val.includes(hexToRgb(oldColor_bis))   ) {
          return newColor;
        }
        else if (val == oldColor2 || val == hexToRgb(oldColor2) || val.includes(oldColor2) || val.includes(hexToRgb(oldColor2))) {
          return newColor2;
        }
      });
      $("*").css("background", function (i, val) {
        val = val.replace(/\s/g, "");
        if (val == oldColor || val == hexToRgb(oldColor) || val.includes(oldColor) || val.includes(hexToRgb(oldColor)) || val == oldColor_bis || val == hexToRgb(oldColor_bis) || val.includes(oldColor_bis) || val.includes(hexToRgb(oldColor_bis))  ) {
          return newColor;
        }
        else if (val == oldColor2 || val == hexToRgb(oldColor2) || val.includes(oldColor2) || val.includes(hexToRgb(oldColor2))) {
          return newColor2;
        }
      });
    }
    //////////////////////////////////
  }

  disconnect () {
    tinymce.remove()
  }

  changeColor(event){
    function hexToRgb(hex) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? "rgb(" + parseInt(result[1], 16) + "," + parseInt(result[2], 16) + "," + parseInt(result[3], 16) + ")" : null;
    }
    if ($("#condition_change_color").val() == "true" ){
      var newColor = $("#new_color_1").val();
      var oldColor = "#3fb0ac";
      var oldColor_bis = "#3eb0ac"
      var newColor2 = $("#new_color_1").val();
      var oldColor2 = "#1d5050";
      $("*").css("color", function (i, val) {
        val = val.replace(/\s/g, "");
        if (val == oldColor || val == hexToRgb(oldColor) || val.includes(oldColor) || val.includes(hexToRgb(oldColor)) || val == oldColor_bis || val == hexToRgb(oldColor_bis) || val.includes(oldColor_bis) || val.includes(hexToRgb(oldColor_bis))   ) {
          return newColor;
        }
        else if (val == oldColor2 || val == hexToRgb(oldColor2) || val.includes(oldColor2) || val.includes(hexToRgb(oldColor2))) {
          return newColor2;
        }
      });
      $("*").css("background", function (i, val) {
        val = val.replace(/\s/g, "");
        if (val == oldColor || val == hexToRgb(oldColor) || val.includes(oldColor) || val.includes(hexToRgb(oldColor)) || val == oldColor_bis || val == hexToRgb(oldColor_bis) || val.includes(oldColor_bis) || val.includes(hexToRgb(oldColor_bis))  ) {
          return newColor;
        }
        else if (val == oldColor2 || val == hexToRgb(oldColor2) || val.includes(oldColor2) || val.includes(hexToRgb(oldColor2))) {
          return newColor2;
        }
      });
    }
  }
  introJsLunch(event){
    var steps_js = eval(event.target.dataset.steps);
    steps_js = JSON.parse(steps_js);
    var new_steps = [];
    for(let i = 0; i < steps_js.length; i++){
      if ($(steps_js[i].element).length > 0){
        new_steps.push(steps_js[i]);
      }
    }
    steps_js = new_steps;
    var intro = introJs();
    intro.setOptions({steps: steps_js ,  nextLabel: event.target.dataset.next , prevLabel: event.target.dataset.prev ,doneLabel:event.target.dataset.done, tooltipClass: 'customTooltip'});
    intro.start();
  }


  /**
   *
   * @param {element_id} string
   */


  setPositionOfIntTel(element_id){
    element_id = "#"+element_id+" .intl-tel-wrapper"
    document.querySelectorAll(element_id).forEach(element => {

      this.toggleClassName(element,"p-absolute");

    });
  }




  /**
   *
   * @param {EventTarget} event

   *
   */

  slideToggle(event) {

    let element = document.getElementById("s" + event.target.id);

    this[element.style.height != "0px" ? "slideUp" : "slideDown"](element);
    this.toggleClassName(element.previousElementSibling,"active");

  }

  /**
   *
   * @param {HTMLElement} element
   * @returns {HTMLElement}
   *
   * Cett fonction prend en paramèttre un element html
   *Elle permet de cacher l'élment reçu en paramètre en dinimiuant sa hauteure jusqu'à 0px.
   */

  slideUp(element) {
    element.style.height = this.initHeight(element) + 2 + "px";
    setTimeout(() => {
      element.style.height = "0px";
      element.style.paddingTop = "0px";
      this.setPositionOfIntTel(element.id);
    }, 100);
  }

  /**
   *
   * @param {HTMLElement} element
   * @returns  {HTMLElement}
   * Cett fonction prend en paramèttre un élément html
   *Elle permet de faire apparaître l'elément html caché à l'aide de SlideUp.
   */

  slideDown(element) {
    element.style.paddingTop = "3px";
    element.style.height = this.initHeight(element) + 2 + "px";
    setTimeout(() => {
      element.style.height = "";
      this.setPositionOfIntTel(element.id);
    }, 600);

  }

  /**
   *
   * @param {HTMLElement} element
   * @returns elementHeight
   *
   * Elle permet de savoir la hauteur initiale de l'élément qu'on doit cacher où afficher
   */

  initHeight(element) {
    let elementHeight = 0;
    for (let i = 0; i < element.childElementCount; i++) {
      elementHeight =
          elementHeight < element.children[i].offsetHeight
              ? element.children[i].offsetHeight
              : elementHeight;
    }
    return elementHeight;
  }

  /**
   *
   * @param {HmlElemnt } element
   * @returns
   *
   * Cette fonction prend en paramètre un élément html,
   * elle permet d'ajouter ou de supprimer une classe de la classeList cet élément.
   */
  toggleClassName(element,className) {
    let h1_element = $(element);
    if (h1_element.attr("class").includes(className)) {
      h1_element.removeClass(className);
    } else {
      h1_element.addClass(className);
    }

    return h1_element;
  }



  initIntTel(){
    var inputPhones = document.querySelectorAll(".int-phone");
    var self = this;
    if(inputPhones){
      inputPhones.forEach((phone,index) => {

        // here, the index maps to the error code returned from getValidationError - see readme
        var errorMap = ["Numéro invalide", "Indicatif du pays est invalide", "Trop court", "Trop long", "Numéro invalide"];


        if(phone){
          // initialise plugin
          var iti = intlTelInput(phone, {
            initialCountry: "fr",
            formatOnDisplay:true,
            separateDialCode: true,
            customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
              // return "00 00 00 00 00";
              return "e.g. " + selectedCountryPlaceholder;

            },

          });

          var id_error = "error-msg_"+index,
              id_valid = "valid-msg_"+index,
              id_hidden_field = "tel_"+index;
          var  errorMsg = document.getElementById(id_error),
              validMsg = document.getElementById(id_valid),
              hidden_field = document.getElementById(id_hidden_field)
          self.reset(errorMsg,validMsg,phone,hidden_field,iti);
          // on blur: validate
          phone.addEventListener('blur', function() {
            self.reset(errorMsg,validMsg,phone,hidden_field ,iti);
            if (phone.value.trim()) {
              if (iti.isValidNumber()) {
                validMsg ? validMsg.classList.remove("hide") : "";
              } else {
                phone.classList.add("error");
                var errorCode = iti.getValidationError();
                errorMsg ? errorMsg.innerHTML = errorMap[errorCode] : "";
                errorMsg ? errorMsg.classList.remove("hide") : "";
              }
            }
            console.log(iti.getNumber(),"Le nimero de téléphone est ")
          });

          // on keyup / change flag: reset

          phone.addEventListener('change', self.reset(errorMsg,validMsg,phone,hidden_field,iti));
          phone.addEventListener('keyup', self.reset(errorMsg,validMsg,phone,hidden_field,iti));

        }
      });



    }

  }

  /**
   * @name  get_browser
   * @returns
   * Cette fonction permet de savoir le navigateur qu'utilise l'utilisateur
   */

  get_browser() {
    let ua = navigator.userAgent,
        tem,
        M =
            ua.match(
                /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
            ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: "IE", version: parseInt(tem[1]) || "" };
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\bOPR|Edge\/(\d+)/);
      if (tem != null) {
        return { name: "Opera", version: parseInt(tem[1]) };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }
    return {
      name: M[0],
      version: parseInt(M[1]),
    };
  }


  reset(error,valid,phoneInput,hidden_field,iti) {

    phoneInput ? phoneInput.classList.remove("error") : "";
    error ?  error.innerHTML = "" : "";
    error ?  error.classList.add("hide") : "";
    valid ?  valid.classList.add("hide"): "";
    hidden_field ?  hidden_field.value = iti.getNumber() : "";


  };



  initZindex() {
    let index = [
      ...document.querySelectorAll("#mySidebar DIV"),
      ...document.querySelectorAll("#mySidebar INPUT"),
      ...document.querySelectorAll("#mySidebar I"),
      ...document.querySelectorAll("#mySidebar SPAN"),
      ...document.querySelectorAll("#mySidebar A")
    ];

    for (let j = 0; j < index.length; j++) {
      index[j].style.zIndex = 100;
    }
  }

  toggle() {
    if (this.isopened != 3) {
      this.initZindex()
      this.isopened = 3;
      this.fct($("#mySidebar").css("width") > "0px").then((res) => {
        if (res == true) {
          this.isopened = 1;
        } else {
          this.isopened = 0;
        }
      });
    } else {
      /*********/
    }
  }

  iniFla() {
    let fields = document.querySelectorAll(".flatpickr");

    for (let j = 0; j < fields.length; j++) {
      fields[j].classList.add("fx-input-date-sidbar-menu");
    }
  }

  fct(isopened) {
    return new Promise((resolve, reject) => {
      if (isopened) {
        this.closeNav().then(() => {
          setTimeout(function () {
            $("#mySidebar").css("position", "unset");
            $("#main").css("position", "unset");
            main.classList.remove("openbtn_left");
            main.classList.add("openbtn_right");
            $("#mySidebar").css("display", "none");
            resolve(false);
          }, 500);
        });
      } else {
        this.openNav().then(() => {
          $("#mySidebar").css("position", "absolute");
          $("#main").css("position", "absolute");
          $("#main").css("marginTop", "0px");
          $("#mySidebar").css("display", "block");
          main.classList.add("openbtn_left");
          main.classList.remove("openbtn_right");
          resolve(true);
        });
      }
    });
  }

  openNav() {
    return new Promise((resolve, reject) => {
      document.getElementById("mySidebar").style.width = "366.8px";
      document.getElementById("main").style.marginRight = "366.8px";
      resolve(true);
    });
  }

  closeNav() {
    return new Promise((resolve, reject) => {
      document.getElementById("mySidebar").style.width = "0px";
      document.getElementById("main").style.margin = "0px";
      resolve(true);
    });
  }

  rerender() {
    var row = $("#search");
    var row2 = $("#quick_sort");
    row.insertAfter(row2);
  }

  /**
   * @name load_show_edit_destroy
   * Cette fonction permet d'afficher ou de cacher les boutons ajouter éditer est supprimé des lignes des tableaux de vueListe
   */
  load_show_edit_destroy() {
    var self = this;
    $(function () {
      self.show_edit_destroy_mouse_hover();
      $("#bd").change(function () {
        self.show_edit_destroy_mouse_hover();
      });
    });
  }

  mask_on_dates(){
    console.log("! Mask on dates activated reflex callbacks!");
    const elements = document.getElementsByClassName("date_mask");
    Array.from(elements).forEach((element) => {
      const initialValue = element.value;
      // Check if the initial value is in "aaaa-mm-dd" format
      if (/^\d{4}-\d{2}-\d{2}$/.test(initialValue)) {
        // Format the initial value from "aaaa-mm-dd" to "dd/mm/yyyy"
        const formattedValue = initialValue
          .split("-")
          .reverse()
          .join("/")
          .replace(/-/, "/");

        // Set the formatted value back to the element
        element.value = formattedValue;
      }
      Inputmask({
        alias: "datetime",
        inputFormat: "dd/mm/yyyy", // Specify the input format of your initial dates
        placeholder: "__/__/____",
        showMaskOnHover: false,
      }).mask(element);
    });
  }




  /**
   * @name show_edit_destroy_mouse_hover
   * Cette fonction permet d'afficher ou de cacher les boutons ajouter éditer est supprimé des lignes des tableaux de vueListe
   */

  show_edit_destroy_mouse_hover() {
    $("#table1 tbody td:not(#search)").hover(
        function () {
          if ($(this).parents("tr").attr("id") != "search") {
            $(this).parents("tr").addClass("highlight");
          }
        },
        function () {
          if ($(this).parents("tr").attr("id") != "search") {
            $(this).parents("tr").removeClass("highlight");
          }
        }
    );

    // fonction du tableau pour cacher ou montrer les boutons actions par rangees
    $("a.edit").hide(); // cacher les liens avec la classe edit
    $("img.edit").hide(); // cacher les liens avec la classe edit
    $("a.show").hide(); // cacher les liens avec la classe show
    $("img.show").hide(); // cacher les liens avec la classe show
    $("a.destroy").hide(); // cacher les liens avec la classe destroy
    $("img.destroy").hide(); // cacher les liens avec la classe destroy
    //
    // effet sur chaque rangee du tableau avec id

    $("#table1 tr:not(#search)").hover(
        function () {
          $(this).find("a.edit").addClass("selected").show();
          $(this).find("img.edit").addClass("selected").show();
          $(this).find("a.show").addClass("selected").show();
          $(this).find("img.show").addClass("selected").show();
          $(this).find("a.destroy").addClass("selected").show();
          $(this).find("img.destroy").addClass("selected").show();
        },
        function () {
          $(this).find("a.edit").removeClass("selected").hide();
          $(this).find("img.edit").removeClass("selected").hide();
          $(this).find("a.show").removeClass("selected").hide();
          $(this).find("img.show").removeClass("selected").hide();
          $(this).find("a.destroy").removeClass("selected").hide();
          $(this).find("img.destroy").removeClass("selected").hide();
        }
    );
  }



  togglePassword () {
    const passwordInput = document.getElementById('password');
    const eyeIcon = document.getElementById('eye_icon');
    eyeIcon.classList.toggle("la-eye-slash")
    if (passwordInput.type === 'password') {
      passwordInput.type = 'text';
    } else {
      passwordInput.type = 'password';
    }
  }


  /* Application-wide lifecycle methods
   *
   * Use these methods to handle lifecycle concerns for the entire application.
   * Using the lifecycle is optional, so feel free to delete these stubs if you don't need them.
   *
   * Arguments:
   *
   *   element - the element that triggered the reflex
   *             may be different than the Stimulus controller's this.element
   *
   *   reflex - the name of the reflex e.g. "Example#demo"
   *
   *   error/noop - the error message (for reflexError), otherwise null
   *
   *   reflexId - a UUID4 or developer-provided unique identifier for each Reflex
   */
  beforeReflex(element, reflex, noop, reflexId) {
    console.log("before reflex callback in stimulus");
    if ($(".content-search") && !$(".content-search").hasClass("select2-hidden-accessible") ) {
      if ($(".content-search").hasClass("no-close-select")) {
          $(".content-search").select2({
            
            width: "resolve",
            placeholder: "",
            allowClear: true,
            closeOnSelect: false
          });

        } else {
          $(".content-search").select2({
            
            width: "resolve",
            placeholder: "",
            allowClear: true
          });
          
        }
    }
    $(".content-search").on('select2:select', function () {
      let event = new Event('change', { bubbles: true }) // fire a native event
      this.dispatchEvent(event);
    });
    MicroModal.init();
    this.changeColor();
    this.previouslyFocusedElement = document.activeElement;
    this.mask_on_dates();

  }
  afterReflex(element, reflex, noop, reflexId) {
    console.log("After reflex callback in stimulus");
    if ($(".content-search") && !$(".content-search").hasClass("select2-hidden-accessible") ) {
      if ($(".content-search").hasClass("no-close-select")) {
          $(".content-search").select2({
            
            width: "resolve",
            placeholder: "",
            allowClear: true,
            closeOnSelect: false
          });

        } else {
          $(".content-search").select2({
            
            width: "resolve",
            placeholder: "",
            allowClear: true
          });
          
        }
    }
    $(".content-search").on('select2:select', function () {
      
      let event = new Event('change', { bubbles: true }) // fire a native event
      this.dispatchEvent(event);
    });
    MicroModal.init();
    this.changeColor();
    this.previouslyFocusedElement.focus();
    this.mask_on_dates();
  }
  // Save a reference to the element that should receive focus
  reflexSuccess(element, reflex, noop, reflexId) {
    console.log("success reflex callback in stimulus");
    if ($(".content-search") && !$(".content-search").hasClass("select2-hidden-accessible") ) {
      if ($(".content-search").hasClass("no-close-select")) {
          $(".content-search").select2({
            
            width: "resolve",
            placeholder: "",
            allowClear: true,
            closeOnSelect: false
          });

        } else {
          $(".content-search").select2({
            
            width: "resolve",
            placeholder: "",
            allowClear: true
          });
          
        }
    }
    $(".content-search").on('select2:select', function () {
      
      let event = new Event('change', { bubbles: true }) // fire a native event
      this.dispatchEvent(event);
    });
    MicroModal.init();
    this.changeColor();
    this.mask_on_dates();
  }

  reflexError(element, reflex, error, reflexId) {
    console.log("Error reflex callback in stimulus");
    if ($(".content-search") && !$(".content-search").hasClass("select2-hidden-accessible") ) {
      if ($(".content-search").hasClass("no-close-select")) {
          $(".content-search").select2({
            
            width: "resolve",
            placeholder: "",
            allowClear: true,
            closeOnSelect: false
          });

        } else {
          $(".content-search").select2({
            
            width: "resolve",
            placeholder: "",
            allowClear: true
          });
          
        }
    }
    $(".content-search").on('select2:select', function () {
      
      let event = new Event('change', { bubbles: true }) // fire a native event
      this.dispatchEvent(event);
    });
    MicroModal.init();
    this.changeColor();
    this.mask_on_dates();
  }
}